<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('simple.import_campaign_users') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$close()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <v-wait for="whatsapp_campaign_add_user">
                    <loading slot="waiting" />
                    <div class="modal-body">
                      <div v-if="showProgress">
                        <div class="mb-2 d-flex justify-content-between">
                          <span>{{ $t('simple.importing_users')}}</span>
                          <span>{{ progressPercent }}%</span>
                        </div>
                        <b-progress :value="progressPercent" max="100" height="20px"></b-progress>
                        <div class="mt-2 text-center" v-if="!firstProgressReceived">
                          <b-spinner small class="mr-2"></b-spinner>
                          <span class="text-muted">{{ $t('simple.processing') }}...</span>
                        </div>
                        <div class="mt-2 text-muted" v-else>{{ total }} / {{ processed }}</div>
                        <div class="mt-2 text-muted small" v-if="total > 10000">{{ $t('simple.large_import_notice') }}</div>
                      </div>
                      <div v-else>
                        <b-row class="align-items-center mb-3">
                          <b-col sm="12" lg="1">
                            <label class="mb-0">{{ $t('simple.select_from') }}:</label>
                          </b-col>
                          <b-col sm="12" lg="6">
                            <div class="d-flex flex-row">
                              <b-form-radio v-model="select_type" name="select-type-radios" value="1" class="mr-4">
                                {{ $t('simple.file') }}
                              </b-form-radio>
                              <b-form-radio v-model="select_type" name="select-type-radios" value="2" :disabled="!archivedUsersList || archivedUsersList.length === 0">
                                {{ $t('simple.archive') }}
                              </b-form-radio>
                            </div>
                          </b-col>
                        </b-row>
                        <b-row class="align-items-center" v-if="select_type === '1'">
                            <b-col sm="1">
                                <label for="campaign_audience">{{ $t('simple.file') }}<span
                                        class="text-danger"></span>:</label>
                            </b-col>
                            <b-col sm="12" lg="4" class="mb-2">
                                <div :class="{ 'isInvalid': !file }"
                                    class="media-upload-container d-flex justify-content-center align-items-center">
                                    <div class="position-absolute">
                                        <div class="d-flex flex-column align-items-center text-center">
                                            <font-awesome-icon :icon="'folder-open'" class="text-primary" />
                                            <span class="media-upload-inner-container text-muted font-weight-normal"
                                                v-if="!file">{{ $t('macros.attach_file') }}</span>
                                            <span class="media-upload-inner-container text-muted font-weight-normal"
                                                v-else>{{ $t('macros.change_file') }}</span>
                                            <span
                                                class="media-upload-inner-container text-muted font-weight-normal">(CSV
                                                or Excel)</span>
                                            <span class="media-upload-inner-container text-muted font-weight-normal">
                                                (Max 50MB)</span>
                                        </div>
                                    </div>
                                    <b-form-file id="campaign_audience" v-model="file" plain
                                        :accept="whatsapp_campaign_settings.document_accepted_types"
                                        @input="addFile(file, whatsapp_campaign_settings.document_size_limit)"
                                        class="media-upload-button h-100 w-100">
                                    </b-form-file>
                                </div>
                            </b-col>
                            <b-col sm="4" v-if="file" class="mb-2">
                                <div class="position-relative media-preview-container d-flex" style="border-radius: 10px;">
                                    <div class="align-self-center p-2">
                                        <font-awesome-icon :icon="'file'" />
                                        <span>{{ file.name }}</span>
                                    </div>
                                    <b-btn size="sm" class="preview-remove-button position-absolute" variant="danger"
                                        @click="removeFile">
                                        <font-awesome-icon :icon="'times'" />
                                    </b-btn>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="align-items-center  mb-3 ml-md-5 pl-3" v-if="select_type === '1'">
                            <b-col>

                                <ul>
                                    <li class="text-muted" style="font-size: 13px;"><a href="/documents/campaign_add_users.xls" download>Download
                                            Sample File</a></li>
                                    <li class="text-muted" style="font-size: 13px;">{{ $t('simple.audience_col_desc') }}</li>
                                    <li class="text-muted" style="font-size: 13px;">{{ $t('simple.audience_phone_desc') }}</li>
                                </ul>
                            </b-col>
                        </b-row>
                        <b-row class="align-items-center mb-3" v-if="select_type === '2' && archivedUsersList.length > 0">
                          <b-col sm="12" lg="1" class="mb-1">
                            <label class="mb-0">{{ $t('simple.archive') }}<span
                                class="text-danger"></span>:</label>
                          </b-col>
                          <b-col sm="12" lg="7" class="mb-1">
                            <multiselect
                                v-validate=""
                                data-vv-name="archived_user"
                                data-vv-value-path="archived_user"
                                v-model="selectedArchiveId"
                                :options="archivedUsersList"
                                :multiple="false"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="true"
                                :allow-empty="true"
                                :searchable="true"
                                :show-labels="false"
                                track-by="id"
                                :custom-label="formatArchiveLabel"
                                placeholder="Select From Archive"
                                name="archive"
                                id="archive"
                            />
                          </b-col>
                        </b-row>
                        <b-row class="align-items-center mb-1">
                            <b-col>
                                <b-form-checkbox v-model="authorizationConfirmation" class="font-weight-bold">{{
                                    $t('simple.audience_auth') }}
                                    <span class="text-danger">*</span></b-form-checkbox>
                            </b-col>
                        </b-row>
                        <b-row class="align-items-center mb-3">
                          <b-col>
                            <b-form-checkbox v-model="addUserToArchive" class="font-weight-bold" v-if="select_type === '1' && file">{{
                                $t('simple.add_uploaded_file_to_archive') }}
                            </b-form-checkbox>
                          </b-col>
                        </b-row>
                        </div>
                    </div>

                    <div class="modal-footer">

                        <b-button @click="$close(false)" variant="secondary" :disabled="showProgress">{{ $t('simple.cancel') }}</b-button>

                        <b-button variant="success" @click.prevent="uploadAudience"
                            :disabled="showProgress || !authorizationConfirmation || (select_type === '1' && !file) || (select_type === '2' && !selectedArchiveId)">{{ $t('simple.add_users') }}</b-button>

                    </div>
                </v-wait>

            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';


export default {
    async beforeDestroy() {
        this.stopPolling();
        await this.fetchWhatsappCampaingUsers({ account_id: this.$route.params.account_id, campaign_id: this.$route.params.campaign_id })
    },
    data() {
        return {
            file: null,
            authorizationConfirmation: true,
            addUserToArchive: false,
            showProgress: false,
            firstProgressReceived: false,
            progressPercent: 0,
            processed: 0,
            total: 0,
            importId: null,
            archivedUsersList: [],
            selectedArchiveId: null,
            archived_users_api: '/api/v1/whatsapp/campaigns/archived-users',
            select_type: '1'
        }
    },
    methods: {

        ...mapActions('Templates', [
            'addUserToWhatsappCampaign',
            'fetchWhatsappCampaingUsers',
            'updateWhatsappCampaignImportStatics',
            'fetchWhatsappCampaignImportStatus'
        ]),
        // On (re)open, resume showing progress for an import already running for this
        // campaign - covers a page refresh or the modal being reopened mid-import.
        async checkOngoingImport() {
            try {
                const data = await this.fetchWhatsappCampaignImportStatus({
                    account_id: this.$route.params.account_id,
                    campaign_id: this.$route.params.campaign_id,
                });
                if (data && data.status === 'processing') {
                    this.importId = data.id;
                    this.showProgress = true;
                    this.firstProgressReceived = data.processed > 0;
                    this.processed = data.processed;
                    this.total = data.total;
                    this.progressPercent = data.percent;
                    this.subscribeProgress();
                    this.startPolling();
                }
            } catch (error) {
                console.log(error);
            }
        },
        subscribeProgress() {
            const campaignId = this.$route.params.campaign_id;
            if (!campaignId) return;
            if (!window.Echo) return;
            if (this._progressChannel) {
                this._progressChannel.stopListening('Whatsapp\\WhatsappCampaignImportProgress');
            }
            this._progressChannel = window.Echo.private(`whatsapp.campaign.import.${campaignId}`)
                .listen('Whatsapp\\WhatsappCampaignImportProgress', (e) => {
                    this.applyProgress({
                        status: e.failed ? 'failed' : (e.percent >= 100 ? 'completed' : 'processing'),
                        processed: e.processed,
                        total: e.total,
                        percent: e.percent,
                        statistics: e.statistics,
                        error_message: e.message,
                    });
                });
        },
        // Fallback in case the WebSocket push never arrives (broadcast misconfig,
        // dropped connection, backgrounded tab) - the DB status row is the source
        // of truth either way, so whichever signal lands first wins.
        startPolling() {
            this.stopPolling();
            this._pollInterval = setInterval(async () => {
                if (!this.showProgress || !this.importId) return;
                try {
                    const data = await this.fetchWhatsappCampaignImportStatus({
                        account_id: this.$route.params.account_id,
                        campaign_id: this.$route.params.campaign_id,
                        import_id: this.importId,
                    });
                    if (data) {
                        this.applyProgress(data);
                    }
                } catch (error) {
                    console.log(error);
                }
            }, 5000);
        },
        stopPolling() {
            if (this._pollInterval) {
                clearInterval(this._pollInterval);
                this._pollInterval = null;
            }
        },
        applyProgress(data) {
            if (!this.showProgress) return;

            if (!this.firstProgressReceived) {
                this.firstProgressReceived = true;
            }
            this.processed = data.processed;
            this.total = data.total;
            this.progressPercent = data.percent;

            if (data.status === 'failed') {
                this.showProgress = false;
                this.stopPolling();
                Vue.toasted.error(data.error_message || this.$t('simple.import_failed'));
                return;
            }

            if (data.status === 'completed' || this.progressPercent >= 100) {
                this.showProgress = false;
                this.stopPolling();
                if (data.statistics) {
                    this.updateWhatsappCampaignImportStatics(data.statistics);
                }
                this.fetchWhatsappCampaingUsers({ account_id: this.$route.params.account_id, campaign_id: this.$route.params.campaign_id });
                this.$close(true);
            }
        },
        addFile(file, limit) {
            if (file && !this.checkFileSize(file, limit)) {
                Vue.toasted.error(this.$t('macros.size_limit_alert', {
                    size_limit: limit,
                }));
                this.removeFile();
            }

        },

        checkFileSize(file, size_limit) {
            if (((file.size / 1024) / 1024).toFixed(4) > size_limit) {
                return false
            }

            return true
        },

        removeFile() {
            this.file = null;
        },

        async uploadAudience() {
            let formData = null;

            if (this.file) {
                formData = new FormData();
                formData.append('excel', this.file);
                formData.append('add_to_archive', this.addUserToArchive ? 1 : 0);
            } else if (this.selectedArchiveId) {
                formData = new FormData();
                formData.append('archive_id', this.selectedArchiveId.id);
            } else {
                return;
            }

            this.showProgress = true;
            this.firstProgressReceived = false;
            this.progressPercent = 0;
            this.processed = 0;
            this.total = 0;
            this.importId = null;
            this.subscribeProgress();

            try {
                const response = await this.addUserToWhatsappCampaign({ account_id: this.$route.params.account_id, campaign_id: this.$route.params.campaign_id, file: formData })
                this.importId = response && response.import_id ? response.import_id : null;
                this.startPolling();
            } catch (error) {
                this.showProgress = false;
                const message = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : this.$t('simple.import_failed');
                Vue.toasted.error(message);
            }
        },
      // Get archived users
      getArchivedUsers: async function(){

        // Start waiting
        await axios.get(this.archived_users_api)

            .then((response) => {

              // Response data
              this.archivedUsersList = response.data;
              //console.log(response);

              // Loading stop

            })
            .catch((error) => {

              // Show error
              Vue.toasted.error(this.$t('simple.error_info'));

              // Log to console
              console.log(error);

              // Close modal
              this.$close(true);

              // Loading stop
            });
      },
      formatArchiveLabel(archive) {
        if (!archive) return '';
        const validNumbers = archive.valid_numbers || 0;
        return `${archive.file_name}-( ${validNumbers} ${this.$t('simple.valid_numbers')} )`;
      },
    },

    computed: {
        ...mapGetters({
            whatsapp_campaign_settings: 'Templates/getWhatsappCampaignSettings',
        }),
    },
   mounted() {
    this.getArchivedUsers();
    this.checkOngoingImport();
   },
}
</script>